import React, { useState } from "react";
import "./InfluencerFAQ.css";

const faqs = [
    {
        question: "What is Brandly?",
        answer: "Brandly is a personal branding platform that helps users craft a standout digital presence, attract opportunities, and build authority online."
    },
    {
        question: "How do I join?",
        answer: "Fill out our quick form—we’ll get back within 1–2 days with your unique referral link and toolkit."
    },
    {
        question: "When do I get paid?",
        answer: "Monthly, once your earnings reach $50."
    },
    {
        question: "How much can I earn?",
        answer: "25% of every subscription you refer, paid monthly as long as they stay."
    },
    {
        question: "Do you offer creative assets?",
        answer: "Yes! We’ve got swipe copy, banners, and templates to help you convert easily."
    }
];

export default function InfluencerFAQ() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (index) => {
        setOpenIndex(prev => (prev === index ? null : index));
    };

    return (
        <section className="influencer-faq-section">
            <h2 className="influencer-faq-heading">FAQs</h2>
            <div className="influencer-faq-list">
                {faqs.map((item, index) => (
                    <div
                        className={`influencer-faq-card ${openIndex === index ? "open" : ""}`}
                        key={index}
                        onClick={() => toggle(index)}
                    >
                        <div className="influencer-faq-question-row">
                            <div className="influencer-faq-plus-icon">
                                <span className="horizontal" />
                                <span className="vertical" />
                            </div>
                            <h3 className="influencer-faq-question">{item.question}</h3>
                        </div>
                        <p className={`influencer-faq-answer ${openIndex === index ? "show" : ""}`}>
                            {item.answer}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
}
